import React from "react";
import { projectArchive } from "../data";

const Projects = () => {
  return (
    <section className="pb-8">
      <div className="max-w-3xl">
        <h1 className="font-display text-4xl tracking-tight text-stone-900 dark:text-stone-100 sm:text-5xl">
          Selected projects across AI systems and product engineering.
        </h1>
        <p className="mt-6 text-lg leading-8 text-stone-600 dark:text-stone-300">
          A collection of public projects showcasing real-world systems I've
          built.
        </p>
      </div>

      <ul className="mt-14 grid gap-8 sm:grid-cols-2">
        {projectArchive.map((project) => (
          <li key={project.name}>
            <article className="flex h-full flex-col rounded-3xl border border-stone-200 bg-white p-6 shadow-[0_18px_50px_-24px_rgba(28,25,23,0.18)] dark:border-stone-800 dark:bg-stone-900 dark:shadow-[0_18px_50px_-24px_rgba(0,0,0,0.55)]">
              <div className="flex items-center justify-between gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-stone-900 text-sm font-semibold text-stone-50 dark:bg-stone-100 dark:text-stone-900">
                  {project.accent}
                </div>
                <span className="rounded-full bg-stone-100 px-3 py-1 text-xs font-medium uppercase tracking-[0.18em] text-stone-500 dark:bg-stone-800 dark:text-stone-300">
                  {project.meta}
                </span>
              </div>

              <h2 className="mt-6 text-xl font-semibold text-stone-900 dark:text-stone-100">
                {project.name}
              </h2>
              <p className="mt-3 text-base leading-7 text-stone-600 dark:text-stone-300">
                {project.summary}
              </p>
              <p className="mt-3 flex-1 text-sm leading-7 text-stone-500 dark:text-stone-400">
                {project.detail}
              </p>

              <div className="mt-6">
                {project.href ? (
                  <a
                    href={project.href}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center rounded-full border border-stone-200 px-4 py-2 text-sm font-medium text-stone-700 transition hover:border-stone-300 hover:text-stone-950 dark:border-stone-700 dark:text-stone-200 dark:hover:border-stone-600 dark:hover:text-stone-50"
                  >
                    View project
                  </a>
                ) : (
                  <span className="inline-flex items-center rounded-full border border-stone-200 px-4 py-2 text-sm font-medium text-stone-500 dark:border-stone-700 dark:text-stone-400">
                    Private project
                  </span>
                )}
              </div>
            </article>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Projects;
